// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6dd4a77c","455":"a13021a9"}[chunkId] + ".chunk.js";
};